import React from 'react';

class Footer extends React.Component {
    render() {
        return (
            <div className="footer">
                <footer>Built by <a className="footer-link" href="https://github.com/stanleenwosu">bits_of_lee</a></footer>
            </div>
        )
    }
}

export default Footer